import Backbone from "backbone";
const $ = Backbone.$;

module.exports = Backbone.View.extend({
  tagName: "div",

  events: {
    click: "disablePropagation"
  },

  initialize(o = {}) {
    _.bindAll(this, "openChanged");
    let model = this.model;
    this.config = o.config || {};
    this.horizontal = o.horizontal ? o.horizontal : "right";
    this.pfx = this.config.stylePrefix || "";
    this.target = o.target || {};
    this.direction = o.direction;
    this.contentView = o.contentView;
    this.listenTo(model, 'change:open', this.openChanged);
  },

  updateSize(size) {
    this.model.set("maxHeight", size.height);
    this.model.set("width", size.width);
  },

  updatePosition() {
    const { model } = this;
    let maxHeight = model.get("maxHeight");
    const width = model.get("width");
    const height = model.get("height");

    if (this.target) {  
        const targetRec = this.target[0].getBoundingClientRect();
        var leftPos = targetRec.left ;
        var rightPos = targetRec.right ;
        var topPos = targetRec.top ;
        var bottomPos = targetRec.bottom ;
        const screenHeight = this.config.canvas.frameBody.height();
        const left = rightPos - this.target.width()/2 - width + 27;
        
        const bottomHeight = screenHeight - bottomPos;
        const aboveHeight = topPos;
        if (aboveHeight > bottomHeight) {
            this.$el.css({
                top: `${topPos - height - 20}px`,
                left: `${Math.max(left, 27)}px`,
                right: `auto`,
                bottom: `auto`
            });
            this.$el.addClass('popup-above')
        } else {
            this.$el.css({
                top: `${bottomPos + 15}px`,
                left: `${Math.max(left, 12)}px`,
                right: `auto`,
                bottom: `auto`
            });
        }
    }
  },

  close() {
    const {model} = this;
    model.set("open", false);
    model.trigger('close');
  },

  open() {
    const {model} = this;
    model.set("open", true);
  },

  show() {
    this.updatePosition();
    this.$el.css("display", "block");
  },

  hide() {
    this.$el.remove();
    this.overlay && this.overlay.remove();
  },

  openChanged() {
    const isOpen = this.model.get("open");
    if (isOpen) {
      this.show();
    } else {
      this.hide();
    }
  },

  disablePropagation(e) {
    e.stopPropagation();
  },

  renderContent() {
    const {model, $el} = this;
    if (this.contentView) {
        $el.append(this.contentView.render().el);
    }
  },

  render() {
    const self = this;
    const { model, el, pfx, config, $el, className } = this;
    const body = config.canvas.frameBody;
    const width = model.get('width');
    const height = model.get('height');
    el.className = `${pfx}popup ${className}`;  
    $el.css({'width': width+'px', 'height':height+'px'});
    this.updatePosition();

    this.overlay = $(`<div class="${pfx}overlay"></div>`);
    this.overlay.on('click', function(e) {
        self.close();
    });

    this.renderContent();

    body.append(this.overlay);
    body.append(el);
    
    return this;
  }
});
